import { setSessionStorageItem } from '../../sessionStorage/utils';
import { SESSION_STORAGE_LAST_FILTER_PANEL } from '../../../utils/constants';

export default (filterPanelVar) => {
  return (newFilterPanel) => {
    filterPanelVar(newFilterPanel);
    setSessionStorageItem(SESSION_STORAGE_LAST_FILTER_PANEL, newFilterPanel);
  };
};
